import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection/WebViewDetails.js";
import { CP_EmbedType } from "@mp-commons/modules/ads/adcall/CustomParams.js";
import { AdBreakType } from "@mp-commons/modules/ads/AdUnit.js";
import { ContentResumePolicy } from "@mp-commons/modules/ads/ContentResumePolicy.js";
import { AdResumableTriggerBehaviour, ImaControllerFeatures } from "@mp-commons/modules/ads/ima/AbstractImaController.js";
import { GroupSuccessCriteria } from "@mp-commons/modules/ads/ima/items/VASTImaAdItem.js";
import { ResumeAndGroupPolicyMap } from "@mp-commons/modules/ads/ima/MultipleTagsImaEnrichedControls.js";
import { isMidrollTime, MultipleVASTImaAdCallControllerConfig, VASTAdUnitConfig } from "@mp-commons/modules/ads/ima/MultipleVASTImaAdCallController.js";
import { VideoPolicyRules } from "@mp-commons/modules/ads/vprules/VideoPolicyRules.js";



function getStandardFeatures(): ImaControllerFeatures {
    return {
        autoPlayAdBreaks: false,
        styledAds: true,
        vpaid: google.ima.ImaSdkSettings.VpaidMode.ENABLED,
        mediaPreloading: true,
        enableCustomClickTracking: false
    }
}





export function alterMidrollOnFanplayer(inputUnits: VASTAdUnitConfig[]): VASTAdUnitConfig[] {


    const copied: VASTAdUnitConfig[] = inputUnits ? inputUnits.map(e => {
        return {
            ...e
        };
    }) : [];

    const maybeFirstMidrolls = copied.filter(unit => {
        return unit.unit.breakType == AdBreakType.MIDROLL &&
            isMidrollTime(unit.midrollTime) &&
            (unit.midrollTime.value <= 10);
    });

    maybeFirstMidrolls.forEach((midroll, index) => {
        midroll.contentResumePolicy = ContentResumePolicy.RESUME_ALWAYS;
        midroll.unit.breakType = AdBreakType.PREROLL;
        midroll.midrollTime = null;
    })

    if (maybeFirstMidrolls.length > 0)
        maybeFirstMidrolls[maybeFirstMidrolls.length - 1].contentResumePolicy = ContentResumePolicy.RESUME_ON_SUCCESS;

    return copied;
}


export function getAdvConfiguration(videoPolicy: VideoPolicyRules,
    embedType: CP_EmbedType,
    vwDetect: DetectedWebView,
    isLazyVideoLoad: boolean,
    inputUnits?: VASTAdUnitConfig[]): MultipleVASTImaAdCallControllerConfig {

    const RAGPolicies: ResumeAndGroupPolicyMap = {
        preroll: {
            resume: ContentResumePolicy.RESUME_ALWAYS,
            group_success: GroupSuccessCriteria.AT_LEAST_ONE
        },
        midroll: {
            resume: ContentResumePolicy.RESUME_ALWAYS,
            group_success: GroupSuccessCriteria.AT_LEAST_ONE
        },
        postroll: {
            resume: ContentResumePolicy.NEVER_RESUME,
            group_success: GroupSuccessCriteria.AT_LEAST_ONE
        }
    }

    const baseConfig: MultipleVASTImaAdCallControllerConfig = {
        features: getStandardFeatures(),
        responsive: true,
        preload: {
            enable: true,
            time: 10
        },
        adUnits: embedType == CP_EmbedType.FANPLAYER ? alterMidrollOnFanplayer(inputUnits) : inputUnits,
        adResumableTriggerBehaviour: AdResumableTriggerBehaviour.DEFER_PREROLL_TRIGGER_TO_FIRST_MIDROLL,
        videoPolicy: videoPolicy
    }

    if (embedType == CP_EmbedType.FANPLAYER) {


        RAGPolicies.preroll.resume = ContentResumePolicy.RESUME_ON_SUCCESS;
        RAGPolicies.preroll.group_success = GroupSuccessCriteria.AT_LEAST_ONE;

    }
    if (isLazyVideoLoad && embedType != CP_EmbedType.FANPLAYER) {
        baseConfig.ensureResourceLoadAfterPrerollPercentage = 0.8;
    }

    return baseConfig;

}